export default "__VITE_ASSET__B9shWG$S__"